module.exports = __webpack_public_path__ + "static/img/table-en.36bb863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/n-prenata-test/table-en.png
// module id = O4uJ
// module chunks = 1